import React from 'react';

const CQIntelligence = () => {
  return (
    <div className="flex flex-col h-full bg-white rounded-lg shadow-sm">
      <div className="flex-1 flex items-center justify-center p-12">
        <div className="text-center max-w-lg">
          {/* Cryptique Logo */}
          <div className="mb-8 flex justify-center">
            <img 
              src="/login-logo.png" 
              alt="Cryptique Logo" 
              className="h-16 w-auto"
            />
          </div>
          
          {/* Main Heading */}
          <h1 
            className="text-4xl font-bold mb-6"
            style={{ 
              color: '#1d0c46',
              fontFamily: 'Raleway, sans-serif'
            }}
          >
            Coming Soon
          </h1>
          
          {/* Message */}
          <div className="space-y-4">
            <p 
              className="text-lg text-[#475569] leading-relaxed"
              style={{ fontFamily: 'Raleway, sans-serif' }}
            >
              CQ Intelligence is currently available exclusively to our beta users.
            </p>
            <p 
              className="text-lg text-[#475569] leading-relaxed"
              style={{ fontFamily: 'Raleway, sans-serif' }}
            >
              We're working hard to bring this powerful AI-powered analytics feature to everyone soon. Stay tuned!
            </p>
          </div>
          
          {/* Accent Line */}
          <div 
            className="mx-auto mt-8 h-1 w-24 rounded-full"
            style={{ backgroundColor: '#caa968' }}
          />
        </div>
      </div>
    </div>
  );
};

export default CQIntelligence; 